export default __webpack_public_path__ + "static/media/g_wdt_c_0.7ec8c2a0.mp3";